import React from 'react';
import PropTypes from "prop-types";

const GoogleMapsLink = ({ address }) => {
  const handleClick = (e) => {
    e.preventDefault()
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <a href="#" onClick={handleClick} className="tw-mb-1 tw-text-xs">
      { address }
    </a>
  );
};

GoogleMapsLink.propTypes = {
  address: PropTypes.string.isRequired,
};

export default GoogleMapsLink;
